<template>
    <div class="twoImageText">
        <div class="indexContainer">
            <el-divider class="indexTitle" v-if="val.title">
                <div class="indexTitleMain">
                    <h3 v-if="val.languageId = 1">{{val.title ? val.title : ''}}</h3><br/>
                    <h4>{{val.summary}}</h4>
                </div>
            </el-divider>
            <div>
                <el-row :gutter="10">
                  <template v-for="(item,index) in newCaseslist">
                    <el-col :xs="24" :sm="11" :key="index" v-if="index==0">
                        <div class="newCaseslist" @click="rowClick(item)">
                            <div class="newCaseslistImg">
                                <img :src="item.picUrl" :alt="item.imgAlt">
                            </div>
                            <p>{{item.title}}</p>
                            <span>{{item.releaseTime|dateFormat}}</span>
                        </div>
                    </el-col>
                    <el-col :xs="24" :sm="13" :key="'index' + index" v-else>
                        <div class="coopCasesList" @click="rowClick(item)">
                            <div class="coopCasesListImg">
                                <img :src="item.picUrl" :alt="item.imgAlt">
                            </div>
                            <div class="text">
                                <p>{{item.title}}</p>
                                <span>{{item.releaseTime|dateFormat}}</span>
                            </div>
                        </div>
                    </el-col>
                  </template>
                    <el-col :span="24" v-if="val.more = 1">
                        <el-button class="more" round @click="handleShow">{{val.moreText}}</el-button>
                    </el-col>
                </el-row>
            </div>
        </div>
    </div>
</template>
<script>
export default {
  props: {
    val: {}
  },
    data(){
        return{
          newCaseslist:[],
          queryText:'',
          moduleId:''
        }
    },
    created() {
      this.newCaseslist = this.val.modules ? this.val.modules[0].articles : [];
      this.moduleId = this.val.moduleId;
    },
    methods:{
        handleShow() {
            let routerURL = this.$router.resolve({
                name: 'INNERPAGER',
                query: {
                    model: this.val.module.model,
                    moduleId:this.moduleId,
                    id: this.val.module.id,
                    level: 2,
                    type: Number(this.val.module.model) === 1 ? 2 : 1,
                    languageId: this.val.module.languageId,
                },
            });
            window.open(routerURL.href,'_blank')
        },
        rowClick(row){
            let routerPath = this.$router.resolve({
              name: 'ARTICLEDETAIL',
              query: {
                languageId: this.$route.query.languageId,
                model: this.$route.query.model,
                moduleId:this.moduleId,
                modelId: this.$route.query.id,
                level: this.$route.query.level,
                type: this.$route.query.type,
                id: row.id
              }
            });
            window.open(routerPath.href,'_blank')
        },
    },
    watch: {
      val(val) {
        this.newCaseslist = this.val.modules ? this.val.modules[0].articles : [];
       }
    }
}
</script>
<style lang="less" scoped>
.twoImageText{
    .newCaseslist{
        border-radius: 4px;
        background: #f7f7f7;
        display: inline-block;
        width: 100%;
        overflow: hidden;
        margin-bottom: 10px;
        padding-bottom: 10px;
        text-align:left;
        cursor: pointer;
        .newCaseslistImg{
            width: 100%;
            overflow: hidden;
            height: 235px;
            cursor: pointer;
            img{
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        p{
            padding:0;
            font-size: 16px;
            line-height: 1.5;
            color: #333;
            -webkit-line-clamp:3;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            height: 52px;
            margin: 10px;
            overflow: hidden;
            font-weight: bold;
        }
        span{
            width: 100%;
            display: inline-block;
            color: #666;
            padding:0 10px;
            font-size: 14px;
        }
    }
    .newCaseslist:hover{
        background: #f2f2f2;
        .newCaseslistImg{
            img{
                transform: scale(1.2);
                transition: all 3s;
            }
        }
        p{
            color: #d11a2e;
        }
    }
    .coopCasesList{
        width: 100%;
        overflow: hidden;
        margin-bottom: 10px!important;
        border-bottom: 1px solid #e6e6e6;
        cursor: pointer;
        .coopCasesListImg{
            display: inline-block;
            overflow: hidden;
            border-radius: 4px;
            width: 176px;
            height: 98px;
            float: left;
            margin-bottom: 10px!important;
            img{
                width: 100%;
                height: 100%;
                display: block;
            }
        }
        .text{
            flex: 1;
            font-size: 16px;
            line-height: 24px;
            text-align: left;
            padding-left:186px;
            padding-bottom:15px;
            vertical-align: middle;
            p{
                font-size: 14px;
                color: #666;
                padding:0;
                display:block;
                box-sizing: border-box;
                -webkit-line-clamp:2;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                height: 48px;
                margin: 10px;
                overflow: hidden;
                font-weight: bold;
            }
            span{
                width: 100%;
                display: inline-block;
                color: #666;
                font-size: 14px;
                padding:0 10px;
            }

        }

    }
    .coopCasesList:hover{
        .coopCasesListImg{
            img{
                transform: scale(1.2);
                transition: all 3s;
            }
        }
        .text p{
            color: #d11a2e;
        }
    }
    .coopCasesList:last-child{
        border: none;
    }
    .more{
        padding:10px 50px;
        color: #d11a2e;
        box-shadow: 1px 1px 2px rgba(0, 0, 0,0.2);
        margin-bottom: 50px;
        margin-top: 20px;
    }
    .more:hover{
        background:#f7f7f7;
        border: 1px solid #DCDFE6;
    }
    .el-button:hover{
        border:1px solid #eee;
        color: #d11a2e;
    }
    .el-button:focus{
        color: #d11a2e;
        border-color: #ccc;
        background-color: #f7f7f7;
    }

    @media only screen and (min-width: 768px){
        .newCaseslist{
            p{
                font-weight: normal;
            }
        }
        .coopCasesList .text p{
                font-weight: normal;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/item/patch8.vue